import styled, { keyframes } from 'styled-components';

import { ImageBackgroundLogoIbFullscreen } from '~/assets/images';

const appearOpacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Container = styled.div`
  background: url(${ImageBackgroundLogoIbFullscreen}) 0% / cover fixed,
    ${(props) => props.theme.colors.background};

  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: relative;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 67rem;

  padding: 2rem;

  animation: ${appearOpacity} 180ms ease-in;

  @media (min-width: 768px) {
    padding: 0;
  }

  /* Logo */
  > svg {
    margin: 5.4rem 0 3rem;
  }

  > form {
    width: 100%;

    display: grid;
    grid-template-columns: 1fr;
    gap: 3rem 3.4rem;

    margin: 4.6rem 0 4.4rem;

    @media (min-width: 768px) {
      grid-template-columns: 1fr 1fr;
    }
  }

  h3,
  p {
    color: ${({ theme }) => theme.colors.white};
  }

  h3 {
    margin-top: 3rem;
  }
`;

export const Title = styled.h1`
  font-weight: ${({ theme }) => theme.fontWeight.LatoBold};
  font-size: 3rem;
  color: ${({ theme }) => theme.colors.yellow};

  text-align: center;

  @media (min-width: 425px) {
    font-size: 3.8rem;
  }
`;
